<template>
    <div class="nong-cun">
        <div class="top">
            <!-- 背景图 -->
            <div class="inner">
                <div class="title">农村产权交易数字化解决方案</div>
                <div class="bg"></div>
            </div>
        </div>

        <div class="cont-item" v-for="(item, index) in list" :key="index" :style="{ background: item.background }">
            <div class="inner">
                <div class="header">
                    <div class="title">
                        {{ item.title }}
                    </div>
                    <div v-if="item.sub" class="sub">
                        {{ item.sub }}
                    </div>
                </div>
                <div class="body">
                    <img :src="item.img" alt="" />
                </div>
            </div>
        </div>

        <div class="cont-item">
            <div class="inner">
                <div class="header">
                    <div class="title">服务内容</div>
                    <div class="sub">
                        平台在优化完善体验和功能作为产品研发方向的同时，做到如实反映平台真实运行情况，接受各级行政监督，并积极宣贯最新的政策法规。
                    </div>
                </div>
                <div class="body">
                    <div class="service-list">
                        <div
                            class="item"
                            v-for="(item, index) in serviceList"
                            :key="index"
                            :style="{ background: item.background }"
                        >
                            <div class="title">
                                {{ item.title }}
                            </div>
                            <div class="text">
                                {{ item.text }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CONFIG_PROJECT from '@config/project';

export default {
    head: {
        title: `农村产权交易数字化解决方案·${CONFIG_PROJECT.title}`,
    },
    data() {
        return {
            list: [
                {
                    title: '赋能农村产权交易数字化升级⸺以技术深耕与全链服务助力乡村振兴',
                    sub: `作为国内领先的电子招采服务商，我们始终致力于以技术创新驱动农村产权交易高质量发展。我们深度聚焦乡村振兴战略需求，依托在电子招采领域十余年的技术沉淀与农村产权交易场景的深耕经验，成功打造全流程数字化招采服务平台，并荣幸成为河北省农村产权交易中心官方合作的第三方电子招标采购交易平台。
入选河北省农村产权交易体系是信任，更是责任。未来，我们将持续迭代智能评标、大数据应用等核心功能，携手共建农村产权交易生态圈，以数字技术打通资源流动堵点，为乡村振兴注入可持续的“惠招动力”！`,
                    img: '/images/products/nong-cun/1.png',
                    background: '#F6FBFE',
                },
                {
                    title: '交易种类',
                    img: '/images/products/nong-cun/2.png',
                    background: '#FFFFFF',
                },
                {
                    title: '全形式',
                    img: '/images/products/nong-cun/4.png',
                    background: '#FFFFFF',
                },
                {
                    title: '全流程',
                    img: '/images/products/nong-cun/3.png',
                    background: '#F8F8F8',
                },
                {
                    title: '数据互联互通',
                    sub: `通过跨平台数据对接，实现招标采购、农村产权交易等信息的实时共享，减少重复发布和跨 平台查询的繁琐流程。显著提升招标效率与透明度，促进城乡资源流动，助力乡村振兴。`,
                    img: '/images/products/nong-cun/5.png',
                    background: '#F8F8F8',
                },
            ],

            serviceList: [
                {
                    title: '设备升级巡检',
                    text: '提供开标、评标的软件、硬件支持并保障升级指导和定期巡检服务。',
                    background: '#EBF1FF',
                },
                {
                    title: '招标文件模板',
                    text: '根据最新的政策法规和监管要求，编制最新范本并免费公开发布，为业主及招标代理提供咨询服务。',
                    background: '#FFF3EB',
                },
                {
                    title: '操作培训',
                    text: '对招标代理和投标人提供专业的操作培训，根据实际情况，提供免费的电话咨询。',
                    background: '#F7EFFF',
                },
                {
                    title: '开评标现场支持',
                    text: '在开标、评标现场向招标代理、投标人、评标专家提供专业人员进行现场技术指导服务。',
                    background: '#DEF9F0',
                },
                {
                    title: '7*24小时专业服务',
                    text: '将为全流程平台中的不同角色用户提供专门的客服电话；通过QQ远程协助、TeamViewer等工具远程指导。',
                    background: '#E4F7FF',
                },
            ],
        };
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.nong-cun {
    background-color: #fff;
    width: 100%;
    position: relative;

    .top {
        z-index: 0;
        width: 100%;
        height: 360px;
        background: url('/images/products/erji-bg.png') no-repeat;
        background-size: 100% 100%;
        background-size: cover;

        .inner {
            width: 1200px;
            height: 120px;
            margin: 0 auto;
            position: relative;

            .title {
                width: 600px;
                color: #fff;
                font-weight: bold;
                font-size: 38px;
                position: absolute;
                top: 85px;
                left: 0;
            }
            .bg {
                z-index: 10;
                position: absolute;
                top: 54px;
                right: 100px;

                width: 413px;
                height: 252px;
                background: url('/images/products/nong-cun/icon-top.png') no-repeat;
                background-size: 100% auto;
            }
        }
    }

    .cont-item {
        padding: 42px 0;

        .header {
            .title {
                font-size: 24px;
                text-align: center;
                color: #131415;
                line-height: 1em;
            }

            .sub {
                font-size: 15px;
                color: #131415;
                line-height: 1.5em;
                padding: 0 6px;
                margin-top: 32px;
            }
        }

        .body {
            margin-top: 32px;

            img {
                display: block;
                margin: 0 auto;
            }
        }
    }

    .inner {
        width: 1200px;
        margin: 0 auto;
    }

    .service-list {
        display: flex;

        .item {
            padding: 22px 13px 35px;
            flex: 1;

            & + .item {
                margin-left: 10px;
            }

            .title {
                font-size: 16px;
                color: #131415;
                line-height: 1em;
            }

            .text {
                color: #131415;
                line-height: 1.6em;
                margin-top: 10px;
            }
        }
    }
}
</style>
